import React from 'react'
import LandingCards from '../components/LandingCards'

export default function Categories() {
  return (
    <LandingCards/>
  )
}
